import { render, staticRenderFns } from "./InfoRegistroPreventa.vue?vue&type=template&id=2cc32af4"
import script from "./InfoRegistroPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoRegistroPreventa.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports